import { emptySplitApi as api } from "./emptyApi"

interface ForecastItemDto {
  date: string
  daily_ad_spend: number
  pct_brand: number
  monetization_factor: number
  paid_monetization_factor: number
  triggered_performance_yoy: number
  organic_social_growth: number
  organic_growth: number
  ltv_expansion: number
}

interface RunForecastDto {
  data: ForecastItemDto[]
}

interface RunForecastResponse {
  status: string
  message: string
}

const forecastApi = api.injectEndpoints({
  endpoints: build => ({
    forecastControllerRunForecast: build.mutation<
      RunForecastResponse,
      RunForecastDto
    >({
      query: body => ({
        url: `/forecast/run`,
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: false,
})

export const { useForecastControllerRunForecastMutation } = forecastApi
export type { ForecastItemDto, RunForecastDto, RunForecastResponse }
